export default __webpack_public_path__ + "static/media/YogaMasks.79196f24.gif";